// extracted by mini-css-extract-plugin
export default {"title":"OrganizationCallHistory_title__3Jq9t"};